import Cookies from "js-cookie";

export const setCookie = (cookieName = null, currentTime = null) => {
  return cookieName
    ? // media using custom players
      Cookies.set(cookieName, currentTime)
    : `
        function setCookie(src, id) {
          const media = document.getElementById(id);
          // If user leaves page during function validating media will prevent an error
          if (media) {
            Cookies.set(src, media.currentTime);
          } else {
            console.warn("Media element not found for src:", src);
          }
        }
      `;
};

export const getCookie = (cookieName) => {
  return Cookies.get(cookieName) || null;
};

export const removeCookie = (cookieName) => {
  return Cookies.remove(cookieName);
};
